export var Roles;
(function (Roles) {
    Roles["SystemAdmin"] = "SystemAdmin";
    Roles["CatalogAdmin"] = "CatalogAdmin";
})(Roles || (Roles = {}));
export function hasMorePrivileges(role1, role2) {
    const rolesOrder = [Roles.SystemAdmin, Roles.CatalogAdmin];
    return rolesOrder.indexOf(role1) <= rolesOrder.indexOf(role2);
}
